<script setup lang="ts">
import LogoAnimated from "@/components/logo-animated.vue";
import useLoader from "@/composables/loader";

withDefaults(
  defineProps<{ text?: string }>(),
  { text: 'Loading...' }
)

const { isActive } = useLoader()
</script>

<template>
  <Transition>
    <div v-if="isActive" :class="$style.loader" class="d-flex justify-content-center align-items-center">
      <div class="d-flex flex-column">
        <LogoAnimated :size="300" />
        <div :class="$style['text']" class="p-2 ps-3 pe-3" v-if="text">{{ text }}</div>
      </div>
    </div>
  </Transition>
</template>

<style module lang="scss">
@import "@/assets/variables";

.loader {
  overflow: hidden;
  background: none;
  border: none;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  top: 0;
  left: 0;
  color: $body-color;
  background: rgba(255, 255, 255, 0.4);

  &:global {
    &.v-enter-from, &.v-leave-to {
      opacity: 0;
    }

    &.v-enter-to, &.v-leave-from {
      opacity: 1;
    }

    &.v-enter-active, &.v-leave-active {
      transition: all 150ms ease;
    }
  }
}

.text {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  text-transform: uppercase;
  color: $body-color;
  text-align: center;
  font-size: 25px;
  display: inline-block;
  letter-spacing: 3px;
  background: rgba(255, 255, 255, 0.75);
  line-height: 1;
  border-radius: $border-radius;
}
</style>
